module.exports = __webpack_public_path__ + "img/emblem@2x.4dc60d7b.png";